import { ChangeDetectionStrategy, Component, EventEmitter, Output, input } from '@angular/core';

@Component({
  selector: 'cosmos-collapsed-bar',
  templateUrl: './collapsed-bar.component.html',
  styleUrls: ['./collapsed-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CollapsedBarComponent {
  public readonly titles = input<string[]>(undefined);

  @Output()
  public toggleItem = new EventEmitter<string>();

  openMenu(title: string): void {
    this.toggleItem.emit(title);
  }
}
